import React, { useState } from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { Link } from "@quintype/components";

import translate from "../../translate";
import PlusIcon from "../../atoms/icons/plus-icon";
import MinusIcon from "../../atoms/icons/minus-icon";
import CustomStoryCard3 from "../../molecules/custom-story-card3";

import "./latest-news.m.css";

const LatestNews = ({ collection, className, publisherName }) => {
  const [isOpen, setIsOpen] = useState(false);

  const stories = collection.items.filter((i) => i.type === "story").map((i) => i.story);
  let storiesToLoad = 6;

  if (global.width <= 768) {
    storiesToLoad = 3;
  }

  const handleBlock = () => setIsOpen(!isOpen);

  const slug = publisherName === "quint" ? "/news/hot-news" : "/hot-news";

  return (
    <div styleName={`wrapper ${className}`}>
      <div styleName="collection-header" onClick={handleBlock} id="latest-news-header">
        <span styleName="title">{translate(publisherName, "latest_news")}</span>
        <div styleName="right-side-view">
          <span styleName="top-headlines">{translate(publisherName, "latest_news_sub")}</span>
          <span styleName="toogle-view">{isOpen ? <MinusIcon /> : <PlusIcon />}</span>
        </div>
      </div>
      <div styleName={`${!isOpen ? "hide-content" : ""}`}>
        <div styleName="collection-body">
          {stories.slice(0, storiesToLoad).map((story) => {
            return (
              <CustomStoryCard3
                story={story}
                aspectRatio={[4, 3]}
                defaultWidth={36}
                imageType="image4x3"
                headerType={3}
                key={story.id}
                id="latest-news-story"
                showHeadlineIcon
              />
            );
          })}
        </div>
        <div styleName="show-more-wrapper" id="latest-news-see-more">
          <Link href={slug} styleName="show-more">
            {translate(publisherName, "see_all")}
          </Link>
        </div>
      </div>
    </div>
  );
};

LatestNews.propTypes = {
  collection: object,
  className: string,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

export default connect(mapStateToProps, null)(LatestNews);
